/*
 * 环境守门 — 仅 dev/test/staging 启用调试 UI (settings popover / 详细工具 / 思考过程)
 *
 * BUILD_ENV 由 webpack DefinePlugin 注入 (config/webpack.config.js:585)。prod 下严格隐藏。
 */

declare const __BUILD_ENV__: string

const ENABLED_ENVS = new Set<string>(['local', 'test', 'staging'])

export function isDebugEnvEnabled(): boolean {
  try {
    return ENABLED_ENVS.has(__BUILD_ENV__)
  } catch {
    return false
  }
}

export function getBuildEnv(): string {
  try {
    return __BUILD_ENV__
  } catch {
    return 'unknown'
  }
}
